import { render } from "./CharacterDetails.vue?vue&type=template&id=ab3cd9b8&scoped=true"
import script from "./CharacterDetails.vue?vue&type=script&lang=js"
export * from "./CharacterDetails.vue?vue&type=script&lang=js"

import "./CharacterDetails.vue?vue&type=style&index=0&id=ab3cd9b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3cd9b8"]])

export default __exports__